import React from "react";
import { t } from "i18next";
import { isItemOutOfStock } from "utils/Utils";
import { useSelector } from "react-redux";
import ItemPriceWithDiscount, { PriceRender } from "./DisplayPrice";
import PreviewMediaUrls from "components/brandHeader/PreviewMediaUrls";
import { PlusSquare } from "icons";

//TODO: remove ltr dir from the component, if arabic content support is added for a store from backend in future

const StoreItem = ({
  item,
  showItem = () => {},
  categoryId,
  page,
  showCartIcon = false,
  type,
  price,
  mediaUrl,
  priceClass = "",
  displayQuantityInHeader = false,
  infoContent,
  showPrice = true,
}) => {
  const { selectedStore } = useSelector((state) => state.store);

  return (
    <React.Fragment>
      <div
        className="relative flex-shrink-0 h-100x w-100x p-2"
        onClick={() => showItem(item, categoryId, type)}
      >
        <PreviewMediaUrls
          sourceUrl={mediaUrl ?? item?.itemId?.itemImageURLs?.[0] ?? ""}
        />
      </div>

      <div
        className="relative flex-grow cursor-pointer flex justify-between gap-2 items-start"
        onClick={() => showItem(item, categoryId, type)}
      >
        <div className="flex-1">
          <h2 dir={"ltr"} className="text-16x font-bold text-dark-blue-900">
            {t(
              displayQuantityInHeader
                ? `${item?.itemId?.quantity}x ${item?.itemId?.baseLanguage?.title}`
                : item?.itemId?.baseLanguage?.title
            )}
          </h2>
          <div>
            <p
              dir={"ltr"}
              className="text-13x text-dark-blue-800 leading-19x truncate-line-2 overflow-wrap-anywhere"
            >
              {t(item?.itemId?.baseLanguage?.description)}
            </p>
          </div>
          {showPrice ? (
            price !== undefined ? (
              <PriceRender price={price} className={priceClass} />
            ) : isItemOutOfStock(item?.itemId, selectedStore) ? (
              <div>
                <p className="text-14x  mt-4">
                  <span className="h-8 py-1 px-4 rounded-full border text-brand-text-primary bg-brand-base-primary border-brand-base-primary">
                    {t("Out of stock")}{" "}
                  </span>
                </p>
              </div>
            ) : item?.itemId?.price <= 0 ? (
              <div>
                <p className="text-14x  mt-4">
                  <span className="h-8 py-1 px-4 rounded-full border text-brand-text-primary bg-brand-base-primary border-brand-base-primary">
                    {t("Price On Selection")}{" "}
                  </span>
                </p>
              </div>
            ) : (
              <ItemPriceWithDiscount item={item?.itemId} />
            )
          ) : null}
          {infoContent ? infoContent : null}
        </div>
        {showCartIcon && !isItemOutOfStock(item?.itemId, selectedStore) && (
          <PlusSquare
            className="h-6 w-6 bg-brand-base-primary rounded-4x text-white"
            hideBorder={true}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default StoreItem;
